export default "__VITE_ASSET__f19d5062__"